import { ApiService } from '../../service/api/ApiService'

/**
 * @type {string} Endpoint получения всех банков
 */
const allBankEndpoint = 'bank'

/**
 * Метод получающий банки.
 *
 * @param context Стейт
 * @returns {Promise<null|*>}
 */
const findAllBanks = async (context) => {
  context.commit('fetchBanks')
  try {
    const { data } = await ApiService.get(allBankEndpoint)
    const response = data.data === undefined ? [] : data.data
    context.commit('fetchBanksSuccess', response)
    return response
  } catch (e) {
    const error = ApiService.handleError(e)
    context.commit('fetchBanksError', error)
    return null
  }
}

export default {
  findAllBanks,
}
